// import scrollPolyfill from 'scroll-polyfill';
// scrollPolyfill();
// import { jarallax } from 'jarallax'; // Global
import AOS from 'aos';
import Accordion from 'accordion-js'; // Services
// import Rellax from 'rellax';
import { isCrawlerUserAgent } from 'is-web-crawler';
import Plyr from 'plyr';

import Swiper, { Navigation, Pagination, Autoplay, Mousewheel } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, Mousewheel]);

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'; // Global

window.ns = {
  deltaHeight: null,
  passiveSupported: false,
};

// ns.parralax = () => {
//   jarallax(document.querySelectorAll('.lax'), {
//     speed: 0.85,
//     automaticResize: true,
//   });
// };

ns.services = () => {
  const element = document.getElementsByClassName('block--services');
  if (element.length > 0) {
    const block = '.block--services';
    new Swiper(block + ' .swiper', {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      edgeSwipeDetection: true,
      mousewheel: {
        forceToAxis: true,
        thresholdDelta: 2,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        1440: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },

      navigation: {
        nextEl: block + ' .next',
        prevEl: block + ' .prev',
      },
    });
  }
};

ns.testimonials = () => {
  const element = document.getElementsByClassName('block--testimonials');
  if (element.length > 0) {
    const block = '.block--testimonials';
    const testimonialsSwiper = new Swiper(block + ' .swiper', {
      autoplay: {
        delay: 10000,
      },
      loop: true,
      slidesPerView: 1,
      spaceBetween: 30,
      edgeSwipeDetection: true,
      mousewheel: {
        forceToAxis: true,
        thresholdDelta: 2,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 30,
        },
      },

      pagination: {
        el: block + ' .dots',
        clickable: true,
      },

      navigation: {
        nextEl: block + ' .next',
        prevEl: block + ' .prev',
      },
    });
  }
};

ns.history = () => {
  const element = document.getElementsByClassName('block--history');
  if (element.length > 0) {
    const block = '.block--history';
    const historySwiper = new Swiper(block + ' .swiper', {
      autoplay: {
        delay: 10000,
      },
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 30,
      edgeSwipeDetection: true,
      mousewheel: {
        forceToAxis: true,
        thresholdDelta: 2,
      },

      navigation: {
        nextEl: block + ' .next',
        prevEl: block + ' .prev',
      },
    });
  }
};

ns.burgerMenu = () => {
  const hamburgers = document.querySelectorAll('.hamburger');
  if (hamburgers.length > 0) {
    hamburgers.forEach((hamburger) => {
      hamburger.onclick = () => {
        ns.openClose();
      };
    });
  }
};

ns.openClose = () => {
  let menu = document.querySelector('.navigation');
  let stickyMenu = document.querySelector('.navigation.-sticky');
  let body = document.querySelector('body');

  if (menu.classList.contains('-menu-open')) {
    body.classList.remove('-menu-open');
    // Close
    menu.classList.remove('-menu-open');
    stickyMenu.classList.remove('-menu-open');
    enableBodyScroll(
      document.querySelector('.navigation .navigation--wrapper')
    );
  } else {
    body.classList.add('-menu-open');
    // Open
    menu.classList.add('-menu-open');
    stickyMenu.classList.add('-menu-open');
    disableBodyScroll(
      document.querySelector('.navigation .navigation--wrapper')
    );
  }
};

ns.menuDocking = () => {
  const navigation = document.querySelector('.navigation');

  if (!navigation.classList.contains('-disable-sticky')) {
    // Setup js for burger menu.
    ns.burgerMenu();

    let getDeltaHeight = () => {
      ns.deltaHeight = 300;
    };

    window.addEventListener(
      'resize',
      function (e) {
        getDeltaHeight();
      },
      ns.passiveSupported ? { passive: true } : false
    );

    getDeltaHeight();

    window.addEventListener(
      'scroll',
      function (e) {
        let scrollTop = window.scrollY;
        if (scrollTop > ns.deltaHeight) {
          navigation.classList.remove('-hide');
          navigation.classList.add('-sticky');
          window.setTimeout(() => {
            navigation.classList.add('-show');
          }, 100);
        } else if (scrollTop == 0) {
          navigation.classList.remove('-sticky');
          navigation.classList.remove('-hide');
          navigation.classList.remove('-show');
        } else if (scrollTop < ns.deltaHeight) {
          navigation.classList.add('-hide');
        }
      },
      ns.passiveSupported ? { passive: true } : false
    );
  }
};

ns.faqs = () => {
  let elements = document.querySelectorAll('.accordion-container');
  if (elements.length > 0) {
    elements.forEach((element) => {
      new Accordion(element, {
        duration: 300,
      });
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded');
  const html = document.getElementsByTagName('html')[0];
  if (html.classList.contains('no-js')) {
    html.classList.remove('no-js');
    html.classList.add('js');
  }
  ns.history();
  ns.services();
  ns.faqs();

  ns.testimonials();
  ns.menuDocking();

  var heroVideo = document.querySelector('.hero__video');
  if (typeof heroVideo != 'undefined' && heroVideo != null) {
    var player = new Plyr(document.querySelector('.hero__video'), {
      controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'settings',
        'fullscreen',
      ],
      youtube: {
        noCookie: true,
        rel: 0,
        modestbranding: 1,
        showinfo: 0,
      },
    });
  }

  try {
    const options = {
      get passive() {
        // This function will be called when the browser
        //   attempts to access the passive property.
        ns.passiveSupported = true;
        return false;
      },
    };

    window.addEventListener('test', null, options);
    window.removeEventListener('test', null, options);
  } catch (err) {
    ns.passiveSupported = false;
  }
});

//  Onload overriten by fastbots shitty script
// window.onload = () => {
//   console.log('onload');
//   // ns.parralax();
//   AOS.init({ offset: 200, once: true, disable: isCrawlerUserAgent() });

//   // let elements = document.getElementsByClassName('rellax');
//   // if (elements.length > 0) {
//   //   let rellax = new Rellax('.rellax');
//   // }
// };

// Add my onload safely to the window.onload
window.addEventListener ?
window.addEventListener("load",afterLoad,false) :
window.attachEvent && window.attachEvent("onload",afterLoad);

function afterLoad() {
  console.log('afterLoad');
  AOS.init({ offset: 200, once: true, disable: isCrawlerUserAgent() });
}
